import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { ExecucaoOrcamentaria, ExecucaoOrcamentariaDistribuicao, ExecucaoOrcamentariaLoa, ExecucaoOrcamentariaNew } from '../../models/execucao-orcamentaria.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { AtualizacoesAuditService } from '../../services/atualizacoes-audit.service';
import { ExecucaoOrcamentariaService } from '../../services/execucao-orcamentaria.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';


@Component({
  selector: 'app-detalhe-projeto-execucao-orcamentaria-loa-list',
  templateUrl: './detalhe-projeto-execucao-orcamentaria-loa-list.component.html',
  styleUrls: ['./detalhe-projeto-execucao-orcamentaria-loa-list.component.scss']
})
export class DetalheProjetoExecucaoOrcamentariaLoaListComponent extends BaseFormComponent<ExecucaoOrcamentariaLoa> implements OnInit, OnDestroy {

  @Input() idExecucao: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  data:ExecucaoOrcamentariaNew;
  filteredData:ExecucaoOrcamentariaDistribuicao[];

  deleting:boolean = false;
  list: ExecucaoOrcamentariaLoa[];
  filter: any[];
  permission: any;
  distribution: boolean;
  distributionList: ExecucaoOrcamentariaLoa[];
  vinculo: boolean;
  listAudit: AtualizacoesAudit[];
  collumnOrder: string;
  direction:string;

  constructor(
    private myService: ExecucaoOrcamentariaService,
    private auditService: AtualizacoesAuditService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.permission = this.activatedRoute.snapshot.data['permission'];
      this.listAudit = this.activatedRoute.snapshot.data['audit'];
      this.initForm();
      this.initList();
    });
    
    this.addSub(EventSharedService.get('reloadPermissionLoaList').subscribe((res) => {
      this.permission = res;
    }))
    this.addSub(EventSharedService.get('vinculo').subscribe((status) => {
      if (status) {
        this.initList();
      }
      this.distribution = false;
      this.vinculo = false;
    }));
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    this.loading();
    this.addSub(
      this.myService.getLoaList(this.idExecucao).subscribe({
        next: (res) => {
          this.data = res?.execucaoOrcamentaria;
          this.data?.execucao_orcamentaria_distribuicao?.forEach(item => {
            this.getFormArray().push(this.createFormGroup(item))
          })
          this.filteredData = this.data.execucao_orcamentaria_distribuicao;
          this.filter = res?.filters;
          this.distributionList = res['distribution'];
          this.loaded();
        },
        error: (err) => {
          this.loaded();
          console.error(err)
        },
      })
    )
  }

  initForm() {
    this.form = new FormGroup({
      atribuicao: new FormArray([]),
      auto_dotacao: new FormControl(null),
    });
  }

  createFormGroup(values:ExecucaoOrcamentariaDistribuicao = null): FormGroup {
    return new FormGroup({
      id: new FormControl(values?.id),
      atribuicao_id: new FormControl(values?.atribuicao_id),
      checked: new FormControl(false),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('atribuicao') as FormArray;
  }

  lowercase(name: string) {
    return name.toLocaleLowerCase();
  }

  getDataCreate(): ExecucaoOrcamentaria {
    let data: ExecucaoOrcamentaria;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.idExecucao) {
        this.addSub(
          this.myService.loaUpdate(this.getDataCreate(), this.idExecucao).subscribe({
            next: (res) => {
              this.loaded();
              this.confirmation("Dotação alterada com sucesso!").subscribe(() => {
                window.location.reload();
              })
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
      this.getFormArray().controls.forEach((form, index) => {
        Object.keys(form['controls']).forEach((key) => this.getFormArray().controls[index]['controls'][key].markAsDirty())
      })
    }
  }

  fieldMessageRequireds(field, index: number): boolean {
    return this.getFormArray().controls[index].get(field)?.invalid && this.getFormArray().controls[index].get(field)?.dirty;
  }

  fieldErrosFormArray(field, index: number) {
    return this.getFormArray().controls[index].get(field)?.errors;
  }

  novo() {
    this.vinculo = true;
  }

  confirmExcluirSingle(id: number) {
    this.confirmation('Tem certeza que deseja excluir?', '', 'warning', true, 'sw-system').subscribe((confirmed) => {
      if (confirmed && id) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number) {
    this.loading();
    this.myService.loaDelete(id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation().subscribe(() => {
          window.location.reload();
        });
      },
      error: (error) => {
        this.msgError(error.error?.message);
        this.loaded();
      }
    });
  }

  confirmExcluir() {
    this.confirmation('Tem certeza que deseja excluir?', '', 'warning', true, 'sw-system').subscribe((confirmed) => {
      if (confirmed) {
        this.excluirMultiple();
      }
    });
  }

  excluirMultiple() {
    this.loading();
    const data = this.getDataCreate();
    const filterData = data?.atribuicao?.filter((d) => d.checked === true);
    const ids = filterData?.map(d => d.id);
    this.myService.loaDeleteMultiple(ids).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation().subscribe(() => {
          window.location.reload();
        });
      },
      error: (error) => {
        this.msgError(error.error?.message);
        this.loaded();
      }
    });
  }

  auditRefresh(){
    let audit = {
      budget_id: this.idExecucao,
      budget_assoc_fpe_id: this.idExecucao,
    };

    this.addSub(
      this.auditService.getAtualizacoes(audit).subscribe((res)=>{
        this.listAudit = res;
        EventSharedService.get('auditRefresh').emit(res);
      })
    );
  }

  formatSubprojeto(item:ExecucaoOrcamentariaDistribuicao): string{
    const subprojeto = item?.execucao_orcamentaria_carteira?.subprojeto;
    const acao = item?.execucao_orcamentaria_carteira?.acao;
    var subprojetoFix = subprojeto == '01'? '00' : subprojeto;
    return subprojetoFix + acao;
  }

  selectAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.atribuicaoControls.controls.forEach(control => {
      control.get('checked')?.setValue(checked);
    });
  }

  get atribuicaoControls(): FormArray {
    return this.form.get('atribuicao') as FormArray;
  }

  orderData(column:string): void{
    if (column === this.collumnOrder) {
      this.direction = this.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.direction = 'asc';
    }
    this.collumnOrder = column;

    const currentData = this.data.execucao_orcamentaria_distribuicao;

    this.filteredData = [...currentData].sort((a, b) => {
      
      var valueA = a.execucao_orcamentaria_carteira?.[column];
      var valueB = b.execucao_orcamentaria_carteira?.[column];
      if(column == 'subprojeto'){
        valueA = this.formatSubprojeto(a);
        valueB = this.formatSubprojeto(b);
      }
      if (valueA == null) return 1;
      if (valueB == null) return -1;
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return this.direction === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }
      return this.direction === 'asc'
        ? (valueA > valueB ? 1 : -1)
        : (valueA < valueB ? 1 : -1);
    });
  }

  //detecta o ctrl+s, evita que o navegador faça o evento padrão e chama a função de salvar
  @HostListener('document:keydown.control.s', ['$event'])
  onCtrlS(event: KeyboardEvent): void {
    event.preventDefault(); 
    this.salvar();
  }
}
